import { IconName, library } from '@fortawesome/fontawesome-svg-core'
import {
  faStar,
  faHandHoldingHeart,
  faClock,
  faStickyNote,
  faComment,
  faAward,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Chip from 'Root/App/Item/Chip'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

import styles from './index.module.css'

library.add(
  faStar,
  faHandHoldingHeart,
  faClock,
  faStickyNote,
  faComment,
  faAward
)

const benefitsList = [
  {
    title: 'Insegnante esperto',
    description: ` Ogni lezione che trovi in questo corso è creata con passione ed è frutto
        dell'esperienza di [creator]. Puoi entrare in contatto direttamente
        con l'insegnante e rimanere sempre aggiornato sulle novità che
        mette a disposizione dei propri studenti.`,

    icon: 'star',
  },
  {
    title: 'Impatto sociale',
    description: `Ogni acquisto supporta direttamente l'insegnante, valorizzando il suo
        lavoro e la sua dedizione nel condividere la conoscenza. Costruisci le
        tue competenze in un ambiente che celebra la libertà espressiva e
        l'autenticità di ogni creator.`,
    icon: 'hand-holding-heart',
  },
  {
    title: 'Impara al tuo ritmo',
    description: `Hai accesso illimitato per sempre ai contenuti digitali, così impari
        comodamente da casa e senza orari. Puoi vedere ogni lezione tutte le
        volte che vuoi, da PC, tablet o mobile. Se l'argomento lo prevede
        puoi ascoltare la lezioni anche in Podcast, mentre sei sul divano, in
        viaggio, mentre fai running.`,
    icon: 'clock',
  },
  {
    title: 'Appunti a portata di mano',
    description: `Annota direttamente nelle lezioni, salva e consulta tutto il materiale
        didattico che ti serve, quando ti serve. Sia che si tratti di
        presentazioni, dispense digitali o di link importanti, crea la tua
        libreria di apprendimento personale. Imparare è più semplice quando hai
        tutto organizzato nel tuo spazio digitale!`,
    icon: 'sticky-note',
  },
  {
    title: 'Supporto continuo',
    description: `Non importa se stai iniziando o sei già a buon punto nel tuo percorso di
        apprendimento: il nostro supporto non va in pausa. Che tu abbia bisogno
        di chiarire un dubbio veloce o di una guida più approfondita, noi siamo
        qui per te.`,
    icon: 'comment',
  },
  {
    title: 'Certificato di completamento ',
    description: `Con il tuo impegno il riconoscimento è assicurato. Completando il corso
        ti meriterai un attestato personalizzato, firmato direttamente
        dall'insegnante. È più di un semplice pezzo di carta: è un simbolo
        del tuo sviluppo, perfetto per impreziosire il tuo CV e il tuo profilo
        LinkedIn.`,
    icon: 'award',
  },
]

const Benefits = ({ creatorName }) => {
  return (
    <section className={styles.benefitsWrapper} aria-label="Course Benefits">
      <Title className={styles.benefistTitle}>
        Cosa rende speciale questo corso
      </Title>

      <div className={styles.benefitsListGrid}>
        {benefitsList.map((benefit, index) => (
          <div key={`course-benefit-${index + 1}`}>
            <Chip
              icon={
                <div className={styles.benefitIconWrapper}>
                  <FontAwesomeIcon
                    className={styles.benefitIcon}
                    icon={['fas', benefit.icon as IconName]}
                  />
                </div>
              }
              highlight
              highlightCustomClass="flex-col gap-y-3"
            >
              <span className="flex flex-col gap-y-1">
                <Title className={styles.benefitItemTitle}>
                  {benefit.title}
                </Title>
                <Paragraph className={styles.benefitItemParagraph}>
                  {benefit.description.replace('[creator]', creatorName)}
                </Paragraph>
              </span>
            </Chip>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Benefits
